import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { CardHeader } from '../ui/CardHeader';
import { DisplayValue } from '../ui/DisplayValue';
import { Pill } from '../ui/Pill';
import { SurfaceCard } from '../ui/SurfaceCard';
import type { WeatherView } from '../../weather/format';

interface RainPressureCardProps {
  view: WeatherView;
  onOpenHistory: () => void;
}

export function RainPressureCard({ view, onOpenHistory }: RainPressureCardProps) {
  return (
    <SurfaceCard>
      <CardHeader title="Apă & presiune" onOpenHistory={onOpenHistory} />

      <Box
        sx={{
          display: 'flex',
          alignItems: 'flex-end',
          justifyContent: 'space-between',
          gap: '16px',
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
          <Typography
            component="span"
            sx={(theme) => ({ fontSize: 12, fontWeight: 500, color: theme.palette.weather.faint })}
          >
            Precipitații
          </Typography>
          <DisplayValue>{view.precipitation}</DisplayValue>
        </Box>
        <Pill>{view.rainStatus}</Pill>
      </Box>

      <Box
        sx={(theme) => ({
          display: 'flex',
          justifyContent: 'space-between',
          fontSize: 13,
          color: theme.palette.weather.soft,
        })}
      >
        <span>Intensitate</span>
        <Box
          component="span"
          sx={(theme) => ({ color: theme.palette.weather.ink, fontWeight: 500 })}
        >
          {view.rainRate}
        </Box>
      </Box>

      <Box sx={(theme) => ({ height: '1px', backgroundColor: theme.palette.weather.line })} />

      <Box
        sx={{
          display: 'flex',
          alignItems: 'flex-end',
          justifyContent: 'space-between',
          gap: '12px',
          flexWrap: 'wrap',
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
          <Typography
            component="span"
            sx={(theme) => ({ fontSize: 12, fontWeight: 500, color: theme.palette.weather.faint })}
          >
            Presiune
          </Typography>
          <DisplayValue>
            {view.pressureValue}
            <Box
              component="span"
              sx={(theme) => ({ fontSize: 17, color: theme.palette.weather.faint })}
            >
              {' '}
              hPa
            </Box>
          </DisplayValue>
        </Box>
        <Pill tone="accent">
          <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: '7px' }}>
            <span aria-hidden>{view.pressureArrow}</span>
            <span>{view.pressureTrend}</span>
          </Box>
        </Pill>
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        <Box
          aria-hidden
          sx={(theme) => ({
            position: 'relative',
            height: 8,
            borderRadius: `${theme.radii.pill}px`,
            background: `linear-gradient(90deg, ${theme.palette.weather.line}, ${theme.palette.weather.accentSoft})`,
          })}
        >
          <Box
            sx={(theme) => ({
              position: 'absolute',
              top: -4,
              left: view.pressurePosition,
              width: 3,
              height: 16,
              borderRadius: `${theme.radii.pill}px`,
              backgroundColor: theme.palette.weather.accent,
              transition: 'left 1s ease, background-color .5s ease',
            })}
          />
        </Box>
        <Box
          sx={(theme) => ({
            display: 'flex',
            justifyContent: 'space-between',
            fontSize: 12,
            color: theme.palette.weather.faint,
          })}
        >
          <span>980 · furtună</span>
          <span>1013 · normal</span>
          <span>1040 · senin</span>
        </Box>
      </Box>
    </SurfaceCard>
  );
}
